<template>
  <van-popup v-model:show="data.show" round>
    <div class="container">
      <div class="pay_popup">
        <img class="icon_failed" src="~/assets/images/reader/icon-reader-recharge-success.svg" alt="">
        <p class="title">{{ $t('reader.recharge_failed') }}</p>
        <p class="description">{{ $t('reader.contact_service') }}</p>
        <div class="got_it_btn" @click="closePopup">{{ $t('reader.return_to_the_recharge_page') }}</div>
        <img class="icon_c" src="~/assets/images/reader/icon-reader-popup-close.png" alt="" @click="closePopup">
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive} from 'vue'

const route = useRoute()
const data = reactive({
  show: false
})

const open = () => {
  //   获取到同一订单的order_no
  const orderNo = localStorage.getItem('order_no')
  if (!orderNo) {
    // 如果没有，说明从来没弹过，直接弹出弹窗
    data.show = true
  } else {
    if (orderNo === route.query.order_no) return false
    data.show = true
  }
  localStorage.setItem('order_no', route.query.order_no)
}

const closePopup = () => {
  data.show = false
  upadteOrderStatus()
}

// 更新订单状态
const upadteOrderStatus = async () => {
  const order_no = route.query.order_no
  let order_status = ""
  const payChannel = route.query.pay_channel
  if (payChannel === 'paypal') {
    order_status = route.query.commit === 'cancel' ? 4 : 3
  } else {
    order_status = route.query.status === 'CLOSED' ? 4 : 3
  }

  const body = {
    order_no,
    order_status
  }
  try {
    await useClientFetch('/api/pay/update-order-status', {
      method: 'POST',
      body
    })
    window.location.reload()
  } catch (e) {
    console.error(e)
  }
}

defineExpose({
  open
})
</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;

}

.container {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

  .pay_popup {
    width: 302px;
    height: 243px;
    border-radius: 20px;
    background: #FF1979;
    background: url('~/assets/images/reader/icon-reader-pay-success.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 10px 21px 21px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      font-family: 'SFPro', 'SFPro';
      font-weight: 600;
      font-size: 19px;
      color: #222222;
      line-height: 22px;
      text-align: center;
      font-style: normal;
    }

    .description {
      width: 100%;
      font-family: 'SFPro', 'SFPro';
      font-weight: 400;
      font-size: 15px;
      color: #65676E;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      margin-top: 8px;
    }

    .icon_failed {
      height: 73px;
      width: 83px;
    }

    .icon_c {
      position: absolute;
      left: 50%;
      top: calc(100% + 21px);
      width: 25px;
      transform: translateX(-50%);
      height: 25px;
    }

    .got_it_btn {
      width: 100%;
      height: 47px;
      background: linear-gradient(90deg, #FF394D 0%, #FF398F 100%);
      box-shadow: 0px 2 10px 0px rgba(232, 57, 102, 0.3), inset 0px 3 8px 0px rgba(255, 190, 217, 0.8);
      border-radius: 23px;
      font-family: 'SFPro', 'SFPro';
      font-weight: 600;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 47px;
      text-align: center;
      font-style: normal;
      margin-top: 18px;
    }
  }
}

</style>
